export const loanCarPaymentOption = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    dialogType: 'drawer',
    dialogClickModal: false,
    rowKey: "index",
    column: [{
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "进件编号",
            prop: "businessCode",
            search: true,
            display: true,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            search: false,
            display: true,
        },
        {
            label: "产品类型",
            prop: "rentType",
            search: true,
            searchMultiple: true,
            searchClearable: true,
            type: "select",
            display: false,
            dicData: [],
        },
        {
            label: "租赁人",
            search: true,
            prop: "name",
            display: true,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
        },
        {
            label: "类型",
            prop: "status",
            type: "select",
            search: false,
            dicData: [{
                label: "继续还款",
                value: 0
            }, ]
        },
        {
            label: "计划还款时间",
            prop: "repaymentDate",
            hide: false,
        },
        {
            label: "待收总额",
            prop: "amountImposed",
            hide: false,
        },
        {
            label: "实收总额",
            prop: "grossReceived",
            hide: true,
        },
    ],
}
